import { render, staticRenderFns } from "./BlankItem.vue?vue&type=template&id=f303fede&scoped=true&"
import script from "./BlankItem.vue?vue&type=script&lang=js&"
export * from "./BlankItem.vue?vue&type=script&lang=js&"
import style0 from "./BlankItem.vue?vue&type=style&index=0&id=f303fede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f303fede",
  null
  
)

export default component.exports